import { render, staticRenderFns } from "./AddTaskAction.vue?vue&type=template&id=c1f76522&scoped=true"
import script from "./AddTaskAction.vue?vue&type=script&lang=ts"
export * from "./AddTaskAction.vue?vue&type=script&lang=ts"
import style0 from "./AddTaskAction.vue?vue&type=style&index=0&id=c1f76522&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f76522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f76522')) {
      api.createRecord('c1f76522', component.options)
    } else {
      api.reload('c1f76522', component.options)
    }
    module.hot.accept("./AddTaskAction.vue?vue&type=template&id=c1f76522&scoped=true", function () {
      api.rerender('c1f76522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/AddTaskAction.vue"
export default component.exports